export interface AuthPillState {
  readonly isAuthenticated: boolean;
  readonly firstName: string | null | undefined;
  readonly hovered: boolean;
}

/**
 * The auth pill's text (bundle `us()` l.14799, repaired by UI-R2): signed out it reads `SIGN IN`
 * from the first paint and never carries the bundle's placeholder string; signed in it shows the
 * first name (or `ACCOUNT`) and `SIGN OUT?` while hovered.
 */
export function authPillLabel({ isAuthenticated, firstName, hovered }: AuthPillState): string {
  if (!isAuthenticated) return 'SIGN IN';
  if (hovered) return 'SIGN OUT?';
  return firstName?.toUpperCase() || 'ACCOUNT';
}
